import { IFloatingFilterComp, IFloatingFilterParams } from "ag-grid-community";
import { formatMessage } from "lib/globalize-util";
import { DATATEST } from "constants/integration";

interface IParams extends IFloatingFilterParams {
    onClick: (e?: MouseEvent) => void;
    showDefaultItem: boolean;
}
class DefaultRowToggleRenderer implements IFloatingFilterComp {
    declare eGui: HTMLElement;
    declare eValue: HTMLElement;
    declare clickListener: (ev: MouseEvent) => any;
    private buildBaseElement(params: IParams) {
        const { onClick, showDefaultItem } = params;
        this.eGui = document.createElement("div");
        if (onClick) {
            this.eGui.className = "defaultValueHeader";
            const anchor = document.createElement("a");
            anchor.setAttribute("data-test", DATATEST.ASSORTMENTS.DEFAULT_ROW.DEFAULT_ROW_TOGGLE);
            anchor.innerText = showDefaultItem ? formatMessage("Hide default row") : formatMessage("Show default row");
            anchor.addEventListener("click", onClick);
            this.eGui.appendChild(anchor);
            this.clickListener = onClick;
        }
    }

    onParentModelChanged(parentModel, filterChangedEvent) {}

    refresh(params: IParams): boolean {
        this.buildBaseElement(params);
        return true;
    }
    getGui(): HTMLElement {
        return this.eGui;
    }
    destroy(): void {
        this.clickListener && this.eGui.removeEventListener("click", this.clickListener);
    }
    init(params: IParams) {
        this.buildBaseElement(params);
    }
}

export { DefaultRowToggleRenderer };
